import { createMotionProxy } from "../create-proxy"

export const m = /*@__PURE__*/ createMotionProxy()
